package com.xtream.composeapp.viewmodel



import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.xtream.composeapp.SharedBuildKonfig
import com.xtream.data_kmp.PreferencesRepo
import com.xtream.data_kmp.db.repo.SeriesStreamsRepository
import com.xtream.data_kmp.db.repo.UserRepo
import com.xtream.data_kmp.dto.SeriesInfo
import com.xtream.data_kmp.dto.SeriesStream
import com.xtream.data_kmp.dto.TmdbMovie
import com.xtream.data_kmp.remote.createApiService
import io.ktor.client.call.body
import io.ktor.http.isSuccess
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.collectLatest
import kotlinx.coroutines.launch
import kotlinx.serialization.ExperimentalSerializationApi


class SeriesInfoViewModel (
    private val tvStreamsRepo: SeriesStreamsRepository,

    private val userRepo: UserRepo,
    private  val appSettingsRepo: PreferencesRepo,
    seriesId: Int?

) : ViewModel() {

    private val _streamTitleLogoState = MutableStateFlow<String?>(null)
    val streamTitleLogoState: StateFlow<String?> = _streamTitleLogoState
    private val _streamState = MutableStateFlow<SeriesStream?>(null)
    val streamState: StateFlow<SeriesStream?> = _streamState

    private val _recommendedItems = MutableStateFlow<List<SeriesStream>>(emptyList())
    val recommendedItems: StateFlow<List<SeriesStream>> = _recommendedItems
    init {
        loadInfo(seriesId)
        loadRecommendations(seriesId)
    }
    val selectedSeriesViewModel= MutableStateFlow<SeriesInfo?>(null)


    @OptIn(ExperimentalSerializationApi::class)
    @Deprecated("Use loadInfo")
    fun loadSeriesInfo(username:String?, password:String?, serverUrl:String?, streamId: Int?, onSuccess:suspend (tvShowInfo: SeriesInfo?)-> Unit) {


        try {


            if (username.isNullOrEmpty() || password.isNullOrEmpty() || serverUrl.isNullOrEmpty() || streamId == null) return
            viewModelScope.launch(Dispatchers.Default) {
                selectedSeriesViewModel.emit(null)


val apiService = createApiService("$serverUrl${SharedBuildKonfig.SERVER_API}",
    username,
    password,
    )
                val response = apiService.getSeriesInfo(streamId?:-1)


                if (response.status.isSuccess()) {
                    // Log.d("#Response:", ((Clock.System.now().toEpochMilliseconds() - millis) / 1000).toString()+" Sec")

                    val seriesInfo = response.body<SeriesInfo?>()
                    // Log.d("#Response:", "Serialization: "+((Clock.System.now().toEpochMilliseconds() - millis) / 1000).toString()+" Sec, body:\n${seriesInfo}")


                    onSuccess.invoke(seriesInfo)
                    if (seriesInfo != null) {
                        selectedSeriesViewModel.emit(seriesInfo.apply { this.streamId = streamId })
                    }

                }


                //onSuccess.invoke(SeriesInfo())


            }
        } catch (e: Exception) {

        }

    }
/*
    suspend fun loadInfo(vodId: Int?, onSuccess:(vodInfo: SeriesInfo?)->Unit) {
        val serverUrl= userRepo.getUserServerUrl()
        val username= userRepo.getLastLoggedInUser()?.userInfo?.username
        val password= userRepo.getLastLoggedInUser()?.userInfo?.password
        loadSeriesInfo(username,password,serverUrl,vodId,onSuccess)
    }
*/



    fun loadInfo(vodId: Int?, onSuccess: suspend (tvShowInfo: SeriesInfo?) -> Unit={}) {
        if (vodId == null) return
        viewModelScope.launch {
            val serverUrl = userRepo.getUserServerUrl()
            val username = userRepo.getLastLoggedInUser()?.userInfo?.username
            val password = userRepo.getLastLoggedInUser()?.userInfo?.password
            loadSeriesInfo(username, password, serverUrl, vodId, onSuccess = {tvShowInfo ->
                getTMDBLogo(tvShowInfo?.info?.tmdb_id,
                    onFinished = {
                        _streamTitleLogoState.value=it
                    },
                    onError = {
                        _streamTitleLogoState.value=null
                    })
                onSuccess.invoke(tvShowInfo)

            })
        }
    }



    suspend fun getTMDBMovieInfo(stream: SeriesStream?, onFinished: suspend (TmdbMovie?)->Unit, onError: suspend (Exception)->Unit){
        error("implement kmp")
/*

val title:String?= stream?.name?.formatToMovieTitle()


        try {
            val tmdbApiKey =  appSettingsRepo.getPref( ACTIVATION_SERVER_URL_KEY)
            if (title.isNullOrEmpty())  throw Exception("No Title Provided")

            val client = HttpClient(Android) {
                if (Build.VERSION.SDK_INT <= Build.VERSION_CODES.N) {
                    engine {
                        sslManager = { httpsURLConnection ->
                            httpsURLConnection.sslSocketFactory =
                                KtorSslHelper.getUnsafeSSLSocketFactory()
                            httpsURLConnection.hostnameVerifier = HostnameVerifier { _, _ -> true }
                        }
                    }
                }
                install(ContentNegotiation) {

                    json(kotlinx.serialization.json.Json {
                        ignoreUnknownKeys = true
                        isLenient = true
                        encodeDefaults = false

                        explicitNulls = false

                    })
                }

            }
            val response: HttpResponse = client.get {
                url("https://api.themoviedb.org/3/search/tv?include_adult=false&language=en-US&page=1&query=$title")

                header("Authorization",tmdbApiKey )

                //  parameter("category_id","505" /*"384"*/)
            }
            //println("++++ ${response}")
        val result= response.body<TmdbQueryResult>().results?.firstOrNull{ it?.firstAirDate==stream.releaseDate}
          //  Log.d("SeriesInfo","getTMDBMovieInfo: $result")
            if (result==null) throw Exception("No Result")
            onFinished.invoke(result)
        }catch (e:Exception){
            // println("++++ $e")
            onError.invoke(e)
        }*/

    }

     fun getTMDBLogo(tmdbId:String?,onFinished:(String?)->Unit, onError: suspend (Exception)->Unit){


         viewModelScope.launch {
             try {
                 error("impelemnt kmp")
                 /*

                 val tmdbApiKey: String? = appSettingsRepo.getPref(PreferencesRepo.SERVER_TMDB_KEY)

                 if (tmdbId == null) throw Exception("No TMDB ID Provided")
                 val client = HttpClient(Android) {
                     if (Build.VERSION.SDK_INT <= Build.VERSION_CODES.N) {
                         engine {
                             sslManager = { httpsURLConnection ->
                                 httpsURLConnection.sslSocketFactory =
                                     KtorSslHelper.getUnsafeSSLSocketFactory()
                                 httpsURLConnection.hostnameVerifier =
                                     HostnameVerifier { _, _ -> true }
                             }
                         }
                     }
                     install(ContentNegotiation) {

                         json(kotlinx.serialization.json.Json {
                             ignoreUnknownKeys = true
                             isLenient = true
                             encodeDefaults = false

                             explicitNulls = false

                         })
                     }

                 }
                 val response: HttpResponse = client.get {
                     url("https://api.themoviedb.org/3/tv/$tmdbId/images")

                     header("Authorization", tmdbApiKey)

                     //  parameter("category_id","505" /*"384"*/)
                 }
                 //println("++++ ${response}")

                 val tmdbUrl = response.body<TMDBMovieImages>().logos?.let {
                     val logo = it.firstOrNull { itm -> itm?.iso6391?.lowercase() == "en" }
                         ?: it.firstOrNull()
                     logo?.filePath?.addTMDBPrefixImageURL()
                 }
                 if (tmdbUrl == null) throw Exception("No Result")
                 onFinished.invoke(tmdbUrl)*/
             } catch (e: Exception) {
                 // println("++++ $e")
                 onError.invoke(e)
             }
         }
    }




    fun loadRecommendations(id: Int?) {
        if (id==null||id==-1) return
        viewModelScope.launch {
            val stream = getTvShowById(id)
            _streamState.value = stream

            stream?.let {
                val recommended = tvStreamsRepo.getRecommendationsList(
                    stream.categoryId,
                    limit = 15,
                    listOf(stream.streamId)
                )
                /*
            tvStreamsRepo.getRecommendedTvShowsList(
                stream.categoryId,
                limit = 15,
                excludeIds = listOf(stream.streamId)
            )*/
                recommended.collectLatest {
                    _recommendedItems.value = it
                }

            }
        }
    }
    suspend fun  getTvShowById(id: Int?) = tvStreamsRepo.getTvShowByStreamId(id)

}
